export default "__VITE_ASSET__CPGjzMCU__"